export default function VehicleFields({ location, setLocation, milage, setMilage, description, setDescription }) {
  return <>
    <div className="voice-form-row">
      <label className="voice-field">Location<select value={location} onChange={(event) => setLocation(event.target.value)}><option>Iran Khodro</option><option>Isaco</option><option>Option 3</option></select></label>
      <label className="voice-field">Mileage (km)<input type="number" min="0" inputMode="numeric" value={milage} onChange={(event) => setMilage(event.target.value)} onFocus={() => { if (milage === 0) setMilage(""); }} onBlur={() => { if (milage === "") setMilage(0); }} /></label>
    </div>
    <label className="voice-field">Description<textarea value={description} onChange={(event) => setDescription(event.target.value)} rows="2" placeholder="Add a note (optional)" /></label>
  </>;
}

export function VinInput({ vin, setVin, hanldeVinResult }) {
  return <label className="voice-field">VIN<input value={vin} onChange={(event) => setVin(event.target.value)} onBlur={() => hanldeVinResult(vin)} placeholder="Scan a code or enter VIN" autoComplete="off" /></label>;
}
